import React, { FC, useEffect, useId } from 'react'
import { YandexAdvertisingSliceId } from './YandexAdvertisingSliceId'
import classNames from 'classnames'

declare global {
  interface Window {
    yaContextCb: any[]
    Ya: {
      Context: {
        AdvManager: {
          render: (args: { renderTo: string; blockId: string; statId?: number }) => void
        }
      }
    }
  }
}

export interface YandexAdsProps {
  sliceId: YandexAdvertisingSliceId
}

export const YandexAds: FC<
  YandexAdsProps & {
    className?: string
  }
> = ({ sliceId, className }) => {
  const id = useId()

  useEffect(() => {
    const src = 'https://yandex.ru/ads/system/context.js'
    const script = window.document.querySelector(`script[src="${src}"]`)

    if (script === null) {
      const script = document.createElement('script')
      script.src = src
      script.async = true

      window.document.getElementsByTagName('head')[0].appendChild(script)
    }

    ;(window.yaContextCb = window.yaContextCb || []).push(() => {
      window.Ya.Context.AdvManager.render({
        renderTo: id,
        blockId: 'R-A-12822541-1',
        statId: sliceId,
      })
    })
  }, [id])

  return <ins className={classNames('block', className)} id={id} />
}
